// import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

// import { SENTRY_DSN } from 'constants/sentry';
import StoreProvider from 'store/StoreProvider';

import App from './App';

import './index.css';

// Sentry.init({
//   dsn: SENTRY_DSN,
//   integrations: [Sentry.replayIntegration()],
//   tracesSampleRate: 1.0,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>,
);
